import React, { FC, useEffect, useState, useRef } from "react";
import { Button, Modal, Row, Col, Checkbox } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import _ from "lodash";
import "./index.scss";
import {
  UPDATE_USER_INFO,
  INVOKE_WORKFLOW,
  GET_USER_INFO,
} from "reducers/authReducer";
import { useDispatch, useSelector } from "react-redux";
import SaveCardModal from "./SaveCardModal";
import { ReactSVG } from "react-svg";
import { RootState } from "reducers/rootReducer";
import { SocketTopics } from "../../constants/enums";
import { wrapRequestPayload } from "../../helpers/request/RequestPayload";
import { pushNotification } from "utils/notifications";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { HeaderPanel } from "components/Dashboard";

const currencyMap = {
  $: "USD",
  "£": "GBP",
  "€": "EUR",
};

const EditPaymentModal: FC<{
  socket: ISocket;
  onClose: () => void;
  pay?: any;
  disableClose?: boolean;
}> = ({ onClose, socket, pay, disableClose }) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [isCreateNewCardModalVisible, setIsCreateNewCardModalVisible] =
    useState<boolean>(false);
  const { userInfo } = useSelector((state: RootState) => state.auth);
  const { projects } = useSelector((state: RootState) => state.dashboard);

  const workflowId = useRef<any>();
  const [selectedCard, setSelectedCard] = useState<any>(undefined);
  const [paymentMethods, setPaymentMethods] = useState<any>();
  const [saving, setSaving] = useState<boolean>(false);
  const [lastSetupIntent, setLastSetupIntent] = useState<any>();
  const [selectedSubscriptionOption, setSelectedSubscriptionOption] =
    useState<any>(undefined);
  const [paymentSettings, setPaymentSettings] = useState<any>(undefined);
  const [expiresAt, setExpiresAt] = useState<any>();
  const stripeKey: string = process.env.REACT_APP_STRIPE_KEY || "";
  const stripePromise = loadStripe(stripeKey);

  useEffect(() => {
    // createWorkflow();
    listPaymentMethods();
    retriveSetupIntent();
    // createSetupIntent();

    console.log("user info", userInfo);

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/dps/createRecurringPaymentSchedule/reply`,
      (result) => {
        setSaving(false);
        const response = JSON.parse(result.message)?.response;
        if (response?.status) {
          setExpiresAt(undefined);
          pushNotification(
            "Payment subscription successfull",
            "success",
            "TOP_CENTER",
            1000
          );
        } else {
          pushNotification(
            response?.data?.details,
            "error",
            "TOP_CENTER",
            3000
          );
        }
        dispatch(GET_USER_INFO());
      }
    );

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/dps/cancelRecurringPayment/reply`,
      (result) => {
        // setSelectedSubscriptionOption(undefined);
        setSaving(false);
        pushNotification(
          "Payment subscription cancelled",
          "success",
          "TOP_CENTER",
          1000
        );
        dispatch(GET_USER_INFO());
      }
    );

    if (userInfo?.stripe?.subscription) {
      setSelectedSubscriptionOption({
        ...userInfo?.stripe?.subscription,
      });
      setExpiresAt(userInfo?.stripe?.subscription?.expiresAt);
    }
    console.log("payment options", projects);
    setPaymentSettings(projects?.paymentSettings);
  }, []);

  const retriveSetupIntent = () => {
    invokeWorkflow(
      {
        userId: localStorage.getItem("RID"),
        cudbServiceId: "cudb-live",
        op: "retrieveSetupIntent",
      },
      (resp) => {
        if (!resp?.data?.lastSetupIntentId) {
          createSetupIntent();
        } else {
          setLastSetupIntent(resp?.data?.response);
        }
      }
    );
  };

  const createSetupIntent = () => {
    invokeWorkflow(
      {
        userId: localStorage.getItem("RID"),
        cudbServiceId: "cudb-live",
        op: "getSetupIntent",
      },
      (resp) => {
        console.log("get setupIntent workflow response", resp);
        setLastSetupIntent(resp?.data?.response);
        updateUserLastSetupIntentId(resp?.data?.response?.id);
      }
    );
  };

  const listPaymentMethods = () => {
    // listPaymentMethods
    invokeWorkflow(
      {
        userId: localStorage.getItem("RID"),
        cudbServiceId: "cudb-live",
        op: "listPaymentMethods",
      },
      (resp) => {
        console.log("list payment methods workflow response", resp);
        // setLastSetupIntent(resp?.data?.response);

        const paymentMethods = resp?.data?.response?.data || [];
        let methods = [];
        paymentMethods.map((paymentMethod) => {
          methods.push({
            id: paymentMethod.id,
            type: paymentMethod?.card?.brand?.toLowerCase(),
            last4: paymentMethod?.card?.last4,
            expiry: paymentMethod?.card?.exp_year,
          });
        });
        setPaymentMethods(methods);
      }
    );
  };

  const updateUserLastSetupIntentId = (lastSetupIntentId) => {
    dispatch(
      UPDATE_USER_INFO({
        ...userInfo,
        lastSetupIntentId,
        silentRequest: true,
      })
    );
  };

  const chargeSource = (workflow) => {
    let createCustomerPayload = wrapRequestPayload({
      request: {
        op: "charge",
        charge: pay?.data?.amount,
        currency: currencyMap[pay?.data?.currency],
        customerId: userInfo.stripeCustomerId,
        source: selectedCard,
        description: pay?.data?.description,
      },
    });
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/workflow/${workflow}/requestWorkflow`,
      createCustomerPayload
    );
  };

  // const addPaymentMethods = (workflow, customerId, source) => {
  //   let createPaymentMethodPayload = wrapRequestPayload({
  //     request: {
  //       op: "createPaymentMethod",
  //       customerId,
  //       source,
  //     },
  //   });
  //   socket.publishToEvent(
  //     SocketTopics.PublishPageTopics,
  //     `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
  //       "CID"
  //     )}/workflow/${workflow}/requestWorkflow`,
  //     createPaymentMethodPayload
  //   );
  // };

  const deletePaymentMethods = (source) => {
    // const index = paymentMethods.findInde
    invokeWorkflow(
      {
        userId: localStorage.getItem("RID"),
        cudbServiceId: "cudb-live",
        op: "detachPaymentMethod",
        paymentMethodId: source,
      },
      (resp) => {
        console.log("deattach response", resp);
        listPaymentMethods();
        createSetupIntent();
        pushNotification(
          "Payment method deleted successfully",
          "success",
          "TOP_CENTER",
          1000
        );
      }
    );
  };

  const exitWorkflow = (workflow) => {
    let exitWorkflowPayload = wrapRequestPayload({
      request: {
        op: "exit",
      },
    });
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/workflow/${workflow}/requestWorkflow`,
      exitWorkflowPayload
    );
  };

  const subscribeToWorkflowEvents = (workflow) => {
    workflowId.current = workflow;
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/workflow/${workflow}/requestWorkflow/reply`,
      (result) => {
        const parsedResponse = JSON.parse(result.message);
        const response = parsedResponse?.response?.data;
        switch (response?.status) {
          case "03-createCustomer":
            dispatch(
              UPDATE_USER_INFO({
                ...userInfo,
                stripeCustomerId: response?.response?.id,
                silentRequest: true,
              })
            );
            break;
          case "06-createPaymentMethod":
            setIsCreateNewCardModalVisible(false);
            let stripePaymentMethods = userInfo.stripePaymentMethods;
            if (!stripePaymentMethods) stripePaymentMethods = {};
            stripePaymentMethods[response?.response?.id] =
              response?.response?.card;
            dispatch(
              UPDATE_USER_INFO({
                ...userInfo,
                stripePaymentMethods,
                silentRequest: true,
              })
            );
            pushNotification(
              "Payment method added successfully",
              "success",
              "TOP_CENTER",
              1000
            );
            break;
          case "07-deletePaymentMethod":
            let paymentMethods = userInfo.stripePaymentMethods;
            delete paymentMethods[response?.response?.id];
            dispatch(
              UPDATE_USER_INFO({
                ...userInfo,
                paymentMethods,
                silentRequest: true,
              })
            );
            pushNotification(
              "Payment method deleted successfully",
              "success",
              "TOP_CENTER",
              1000
            );
            break;
          case "08-charge":
            const data = {
              ...pay.data,
              transactionId: response?.response?.id,
              outcome: response?.response?.outcome,
              status: response?.response?.status,
            };
            let edit = {
              id: pay.id,
              originalCreatedAt: pay.originalCreatedAt,
              originalPageMessageId: pay.originalPageMessageId,
            };
            dispatch({
              type: "SEND_MESSAGE",
              payload: { message: pay.data.title, type: "pay", data, edit },
            });
            pushNotification(
              "Payment charged successfully",
              "success",
              "TOP_CENTER",
              1000
            );
            setSaving(false);
            handleCancel();
            break;
        }
      }
    );
    // if (!userInfo.stripeCustomerId) {
    //   createCustomer(workflow);
    // }
  };

  const createSchedule = (scheduleType, amount) => {
    setSaving(true);
    let createSchdulePayload = wrapRequestPayload({
      userId: localStorage.getItem("RID"),
      timestamp: new Date().getTime(),
      amount,
      scheduleType,
      userServiceId: localStorage.getItem("selectedOrg") || "cudb-live",
    });
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/dps/createRecurringPaymentSchedule`,
      createSchdulePayload
    );
  };

  const cancelSchedule = () => {
    setSaving(true);
    let createSchdulePayload = wrapRequestPayload({
      userId: localStorage.getItem("RID"),
    });
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/dps/cancelRecurringPayment`,
      createSchdulePayload
    );
  };

  const invokeWorkflow = (requestData, callback) => {
    const request = {
      changes: [],
      configId: process.env.REACT_APP_STRIPE_CONFIG_ID,
      // request: { op: "init" },
      request: {
        ...requestData,
      },
      timeout: 10000,
    };
    dispatch(
      INVOKE_WORKFLOW({
        request,
        callback: (resp) => {
          // if (resp?.data?.workflowId) {
          //   subscribeToWorkflowEvents(resp?.data?.workflowId);
          // }
          // console.log('response', resp);
          callback && callback(resp);
        },
      })
    );
  };

  // useEffect(() => {
  //   if (userInfo) {
  //     if (userInfo?.stripePaymentMethods) {
  //       let methods = [];
  //       Object.keys(userInfo?.stripePaymentMethods ?? {}).map((id) => {
  //         methods.push({
  //           id,
  //           type: userInfo?.stripePaymentMethods?.[id]?.brand?.toLowerCase(),
  //           last4: userInfo?.stripePaymentMethods?.[id]?.last4,
  //           expiry: `${userInfo?.stripePaymentMethods?.[id]?.exp_month}/${userInfo?.stripePaymentMethods?.[id]?.exp_year}`,
  //         });
  //       });
  //       setPaymentMethods(methods);
  //     }
  //   }
  // }, [userInfo]);

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const handleOk = () => {
    setSaving(true);
    chargeSource(workflowId.current);
  };

  return (
    <Modal
      title={pay ? "Select card" : "Saved card"}
      visible={disableClose ? disableClose : isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal payment-layout"
      footer={[]}
      destroyOnClose={true}
      closable={disableClose ? false : true}
      wrapClassName={disableClose ? "payment-modal-wrap" : ""}
      mask={disableClose ? false : true}
    >
      {/* {pay && (
        <Row className="beam-modal analytics-summary-modal">
          <Col span={24}>
            <ul className="incident-information mt-2">
              <li>
                <Row>
                  <Col span={12}>
                    <p>Payment title</p>
                  </Col>
                  <Col span={12}>
                    <p>{pay?.data?.title}</p>
                  </Col>
                </Row>
              </li>

              <li>
                <Row>
                  <Col span={12}>
                    <p>Payment description</p>
                  </Col>
                  <Col span={12}>
                    <p>{pay?.data?.description}</p>
                  </Col>
                </Row>
              </li>

              <li>
                <Row>
                  <Col span={12}>
                    <p>Amount ({pay?.data?.currency})</p>
                  </Col>
                  <Col span={12}>
                    <p>{pay?.data?.amount}</p>
                  </Col>
                </Row>
              </li>
            </ul>
          </Col>
        </Row>
      )} */}

      {/* <div
        className="main-layout"
        style={{ position: "fixed", left: 0, top: 0 }}
      >
        <HeaderPanel socket={socket} dashboard={true} />
      </div> */}

      <Row>
        {paymentMethods?.map((item, idx: number) => (
          <div
            className={`credit-card ${item.type} ${
              selectedCard === item.id ? "selected" : "selectable"
            }`}
            onClick={() => {
              if (pay) {
                setSelectedCard(item.id);
              }
            }}
          >
            <div className="credit-card-last4">{item.last4}</div>
            <div className="credit-card-expiry">{item.expiry}</div>
            <div className="delete">
              <DeleteOutlined
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (
                    window.confirm(
                      "Are you sure you want to delete payment method?"
                    ) == true
                  ) {
                    deletePaymentMethods(item.id);
                  }
                }}
              />
            </div>
          </div>
        ))}

        {lastSetupIntent && paymentMethods && paymentMethods.length === 0 && (
          <div
            className="credit-card new selectable"
            onClick={() => {
              setIsCreateNewCardModalVisible(true);
            }}
          >
            <div className="d-flex flex-column justify-content-center align-items-center">
              <ReactSVG src="/images/plus-icon.svg" />
              <h4 className="mt-3">Add new card</h4>
            </div>
          </div>
        )}
      </Row>

      {pay && (
        <Row className="action-grp mt-3">
          <Col span={24} className="pr-2">
            <Button
              className="beam-btn green-btn cover w-full"
              onClick={handleOk}
              disabled={!selectedCard}
              loading={saving}
            >
              {"Charge"}
            </Button>
          </Col>
        </Row>
      )}

      {isCreateNewCardModalVisible && (
        <Elements
          stripe={stripePromise}
          options={{
            clientSecret: lastSetupIntent.client_secret,
          }}
        >
          <SaveCardModal
            lastSetupIntent={lastSetupIntent}
            onClose={() => setIsCreateNewCardModalVisible(false)}
            onAdd={(source) => {
              // addPaymentMethods(
              //   workflowId.current,
              //   userInfo.stripeCustomerId,
              //   source?.source?.id
              // );
            }}
          />
        </Elements>
      )}

      {!disableClose && (
        <React.Fragment>
          {paymentSettings?.type === "recurring" && (
            <div className="mt-3">
              <h5>Choose your plan</h5>
              {expiresAt && (
                <p>Expires on: {new Date(expiresAt)?.toLocaleDateString()}</p>
              )}

              {paymentSettings?.info?.recurringDetails?.map((item) => {
                return (
                  <Row
                    className="person-item d-flex mt-2"
                    style={{
                      border: `2px solid ${
                        selectedSubscriptionOption?.scheduleType ===
                        item.billingCycle
                          ? "#40CC52"
                          : "#d9d9d9"
                      }`,
                      // backgroundColor: `${value?.value === user.id ? '#f5f5f5': '#fff'}`,
                      cursor: "pointer",
                      boxShadow: "0px 0px 15px 0px rgba(223, 229, 238, 1)",
                    }}
                    onClick={() => {
                      // onClick(user?.obj);
                      setSelectedSubscriptionOption({
                        scheduleType: item.billingCycle,
                        amount: item.amount,
                      });
                    }}
                  >
                    <Col span={14}>
                      <h5>{item.name}</h5>
                      <p>
                        $ {item.amount}/{item.billingCycle}
                      </p>
                    </Col>
                    <Col>
                      <Checkbox
                        className="mb-2 ml-0"
                        checked={
                          selectedSubscriptionOption?.scheduleType ===
                          item.billingCycle
                        }
                      ></Checkbox>
                    </Col>
                  </Row>
                );
              })}

              <Row className="action-grp mt-3">
                <Col span={24}>
                  {!userInfo?.stripe?.subscription?.schedule?.id ||
                  (expiresAt && expiresAt < new Date().getTime()) ? (
                    <Button
                      className="beam-btn green-btn cover w-full"
                      onClick={() => {
                        createSchedule(
                          selectedSubscriptionOption?.scheduleType,
                          selectedSubscriptionOption?.amount
                        );
                      }}
                      loading={saving}
                    >
                      Subscribe
                    </Button>
                  ) : (
                    <Button
                      className="beam-btn orange-btn cover w-full"
                      onClick={() => {
                        cancelSchedule();
                      }}
                      loading={saving}
                    >
                      Cancel subscription
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          )}
          {paymentSettings?.type === "fixed" && (
            <div className="mt-3">
              <h5>Fixed plan</h5>

              <Row
                className="person-item d-flex mt-2"
                style={{
                  border: `2px solid ${
                    selectedSubscriptionOption?.scheduleType ===
                    paymentSettings?.type
                      ? "#40CC52"
                      : "#d9d9d9"
                  }`,
                  // backgroundColor: `${value?.value === user.id ? '#f5f5f5': '#fff'}`,
                  cursor: "pointer",
                  boxShadow: "0px 0px 15px 0px rgba(223, 229, 238, 1)",
                }}
                onClick={() => {
                  // onClick(user?.obj);
                  setSelectedSubscriptionOption({
                    scheduleType: paymentSettings?.type,
                    amount: paymentSettings?.info?.amount,
                  });
                }}
              >
                <Col span={14}>
                  <h5>{paymentSettings?.info?.name}</h5>
                  <p>$ {paymentSettings?.info?.amount}</p>
                </Col>
                <Col>
                  <Checkbox
                    className="mb-2 ml-0"
                    checked={
                      selectedSubscriptionOption?.scheduleType ===
                      paymentSettings?.type
                    }
                  ></Checkbox>
                </Col>
              </Row>

              <Row className="action-grp mt-3">
                <Col span={24}>
                  {!userInfo?.stripe?.subscription?.expiresAt && (
                    <Button
                      className="beam-btn green-btn cover w-full"
                      onClick={() => {
                        createSchedule(
                          selectedSubscriptionOption?.scheduleType,
                          selectedSubscriptionOption?.amount
                        );
                      }}
                      loading={saving}
                    >
                      Pay
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          )}
        </React.Fragment>
      )}
    </Modal>
  );
};

export default EditPaymentModal;
